import AOS from 'aos';
import 'jquery-match-height';
import 'owl.carousel';

export default {
  init() {

    $(document).ready(function() {
        // Check if element is scrolled into view
        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
      
          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();
      
          return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }
        // If element is scrolled into view, fade it in
        $(window).scroll(function() {
          $('.scroll-animations .animate__animated').each(function() {
            if (isScrolledIntoView(this) === true) {
              $(this).addClass('animate__fadeInUp');
            }
          });
        });
      });

    // JavaScript to be fired on all pages
	AOS.init({
		duration: 1300,
		offset: 200,
		once: true,
	});

    $(function() {
        setTimeout(function(){
            //match height
            $('.related-blog-item').matchHeight();
            $('.pricing').matchHeight();
            $('.match-height').matchHeight();
        }, 500);
    });

    $('.carousel').carousel()
      
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(function initMap() {
      const center = new google.maps.LatLng(54.600225, -1.570467);
      var CustomMapStyles = [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ];
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 14,
        center: center,
        styles: CustomMapStyles
      });
      var icon = {
        url: "/wp-content/uploads/2021/06/Temp-Hero-icon.png", // url
        scaledSize: new google.maps.Size(35, 35), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(0, 0) // anchor
      };
      new google.maps.Marker({
        position: map.getCenter(),
        icon: icon,
        map: map,
      });
    });
  },
};

$(function() {
    document.getElementById("BookDemoButton").addEventListener("click", function() {
    let email = document.getElementById("BookDemoInput").value
    if(email == '')
    {
      //change colour of input BG
      document.getElementById("BookDemoInput").style.background = "#ffcaca";  
    }else{
      window.location.href = 'https://induction.mobilerocket.co.uk/temp-hero-demo/?email='+email
    }
    
  });
});

$('#exampleModal').on('shown.bs.modal', function () {
    $('#myInput').trigger('focus')
  })

// Header

// meet the team slider
$(document).ready(function(){
    $('.meet-the-team-carousel').owlCarousel({
      autoplay: 3000, // set autoplay to 3 seconds
          items: 3,
          margin:10,
          loop:true,
          nav:true,
          dots:false,
          center:true,
      responsive:{
          0:{
            items:1,
          },
          600:{
            items:3,
          },
      }
  })
  });


// WEBPACK FOOTER //
// ./scripts/routes/common.js